import { z } from 'zod';

export type AuctionCarCreateForm = {
    id: number,
    start_price: number,
};

export type AuctionCreateForm = {
    start_date: string,
    end_date: string,
    cars: AuctionCarCreateForm[],
    is_published?: 0 | 1,
};

export type AuctionCarCreateFormErrors = {
    id?: string[],
    start_price?: string[],
};

export type AuctionCreateFormErrors = {
    start_date?: string[],
    end_date?: string[],
    cars?: AuctionCarCreateFormErrors[],
};

const AuctionCarCreateFormErrorsSchema = z.object({
    id: z.string().array().optional(),
    start_price: z.string().array().optional(),
});

export const AuctionCreateFormErrorsSchema = z.object({
    start_date: z.string().array().optional(),
    end_date: z.string().array().optional(),
    cars: AuctionCarCreateFormErrorsSchema.array().optional(),
});
